export const quotationEndpoints = (builder) => ({

getHealthQuotationList: builder.query({
        query: (params) => ({
            url: "/GeneralInsurance/get-health-quotation-list",
            method: "GET",
            params: params,
        }),
        providesTags: ["HealthQuotation"],
    }),
deleteHealthQuotation: builder.mutation({
  query: (ids) => ({
    url: "/GeneralInsurance/delete-health-quotation",
    method: "DELETE",
    body: { ids },
  }),
  invalidatesTags: ["HealthQuotation"],
}),

submitHealthQuotation: builder.mutation({
    query: (formData) => ({
        url: "/GeneralInsurance/submit-health-quotation",
        method: "POST",
        body: formData,
    }),
    invalidatesTags: ["HealthQuotation"],
}),

// Other Insurance Quotation
getOtherInsuranceQuotationList: builder.query({
    query: (params) => ({
        url: "/GeneralInsurance/get-other-insurance-quotation-list",
        method: "GET",
        params: params,
    }),
    providesTags: ["OtherInsuranceQuotation"],
}),

deleteOtherInsuranceQuotation: builder.mutation({
  query: ({ quotationIds }) => ({
    url: "/GeneralInsurance/delete-other-insurance-quotation",
    method: "DELETE",
    body: { quotationIds },
  }),
  invalidatesTags: ["OtherInsuranceQuotation"],
}),

submitOtherInsuranceQuotation: builder.mutation({
    query: (formData) => ({
        url: "/GeneralInsurance/save-other-insurance-quotation",
        method: "POST",
        body: formData,
    }),
    invalidatesTags: ["OtherInsuranceQuotation"],
}),

getOtherInsuranceQuotationById: builder.query({
    query: (id) => `/GeneralInsurance/get-other-insurance-quotation/${id}`,
    providesTags: (result, error, id) => [{ type: "OtherInsuranceQuotation", id }, "OtherInsuranceQuotation"],
}),

updateOtherInsuranceQuotation: builder.mutation({
    query: ({ id, ...formData }) => ({
        url: `/GeneralInsurance/update-other-insurance-quotation/${id}`,
        method: "PUT",
        body: formData,
    }),
    invalidatesTags: ["OtherInsuranceQuotation"],
}),

getHealthQuotationById: builder.query({
    query: (id) => `/GeneralInsurance/get-health-quotation-by-id/${id}`,
    providesTags: (result, error, id) => [{ type: "HealthQuotation", id }, "HealthQuotation"],
}),

updateHealthQuotation: builder.mutation({
    query: ({ id, ...formData }) => ({
        url: `/GeneralInsurance/update-health-quotation/${id}`,
        method: "PUT",
        body: formData,
    }),
    invalidatesTags: ["HealthQuotation"],
}),

getQuotationNo: builder.query({
    query: (type) => `/GeneralInsurance/generate-quotation-no?type=${type}`,
}),

getZonesByProduct: builder.query({
    query: (productId) => `/GeneralInsurance/get-zones-by-product?productId=${productId}`,
}),

getPlansByProduct: builder.query({
    query: (productId) => `/GeneralInsurance/get-plans-by-product?productId=${productId}`,
}),

});